import React, { useEffect, useState } from "react";
import Loadspinner from "../../../common/Loadspinner";
import CommonService from "../../../services/CommonService";
// import { Button } from "@material-ui/core";
import AskAnExpertService from "../../../services/AskAnExpertService";

import "./AskAnExpert.css";
import CreateKnowledgeService from "../../../services/CreateKnowledgeService";

import PropTypes from "prop-types";
import { Modal } from "@material-ui/core";
import { Redirect } from "react-router-dom";
/* import Swal from "sweetalert2"; */
/* import { toast } from "react-toastify"; */

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as images from "../../../constants/Images";
import { APICall } from "../../../helpers/API/APICalls";
import { getCommonDropdownData } from "../../../helpers/API/APIEndPoints";
import CommonConstants from "../../../constants/CommonConstants";
import FileExtensionAllowed from "../../../helpers/FileExtensionAllowed.js/FileExtensionAllowed";

function AskQuery(props) {
  const [divisionId, setDivisionId] = useState(1);
  const [platformId, setPlatformId] = useState(0);
  const [systemId, setSystemId] = useState(0);
  const [subSystemId, setSubsystemId] = useState(0);
  const [aggregate, setAggregate] = useState(0);
  const [aggregateList, setAggregateList] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [fileName, setFilename] = useState("");
  const [fileType, setFileType] = useState("");
  const [attachment, setAttachment] = useState();
  const [platformList, setPlatformList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [systemList, setSystemList] = useState([]);
  const [subSystemList, setSubsystemList] = useState([]);
  const [isSystem, setIsSystem] = useState(true);
  const [isLoading, setLoading] = useState(false);
  //const [isAttachment, setIsAttachment] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showModal, setModal] = useState(true);

  const allowedExtensions = [
    "webm",
    "mp3",
    "ppt",
    "docx",
    "pdf",
    "xlsx",
    "jpg",
    "jpeg",
    "png",
    "mp4",
  ];

  const closeModal = () => {
    setModal(false);
    props.handleModal(false);

    setDivisionId(1);
    setPlatformId();
    setSystemId();
    setSystemId();
    setIsSystem(false);
    setTitle("");
    setDescription("");
    setFilename("");
    setFileType("");
    setAttachment("");
  };

  useEffect(() => {
    getLists();
  }, []);

  const getLists = () => {
    getAggregate();
    getSystem(1);
    getDivision();
    getPlatform(1);
  };

  const getAggregate = async () => {
    let requestParams = {
      dropdownName: "aggregate",
      searchText: "",
    };
    const resp = await APICall(getCommonDropdownData, requestParams, "POST");

    if (resp.data.length > 0) {
      setAggregateList(resp.data);
    } else {
      setAggregateList([]);
    }
  };

  const handleTitleChange = (e) => {
    let val = e.target.value.replace(/[$&[\]|<>^*/]/, "");
    setTitle(val);
  };

  const handleDescriptionChange = (e) => {
    let val = e.target.value.replace(/[$&[\]|<>^*/]/, "");
    setDescription(val);
  };

  //division

  const getDivision = async () => {
    setLoading(true);
    const res = await CommonService.getDivisionList();

    if (res) {
      setDivisionList(res);
    }
    setLoading(false);
  };

  const setDivision = (e) => {
    setDivisionId(e.target.value);
    getPlatform(e.target.value);
    getSystem(e.target.value);
  };

  //platform

  const getPlatform = async (divId) => {
    setLoading(true);
    const res = await CommonService.getPlatformList(divId);

    if (res) {
      setPlatformList(res);
    }
    setLoading(false);
  };

  //system

  const getSystem = async (divId) => {
    setLoading(true);
    const res = await CommonService.getSystemList(divId);

    if (res) {
      setSystemList(res);
    }
    setLoading(false);
  };

  const setSystem = (e) => {
    getSubsystem(e.target.value);
    setSystemId(e.target.value);
    if (e.target.value > 0) {
      setIsSystem(false);
    }
  };

  //subsystem

  const getSubsystem = async (id) => {
    setLoading(true);
    const res = await CommonService.getSubSystemList(id);

    if (res) {
      setSubsystemList(res);
    }
    setLoading(false);
  };

  //file

  const fileSelect = (e) => {
    if (e.target.files.length > 0) {
      let fileValidations = FileExtensionAllowed(
        e.target.files[0],
        allowedExtensions,
      );
      console.log(`error Text`, fileValidations);

      if (fileValidations != "") {
        toast(fileValidations);
      } else {
        uploadFile(e.target.files[0], e.target.files[0].type);
      }
    }
  };

  const uploadFile = async (files, type) => {
    let fileData = new FormData();
    fileData.append("file", files);
    setLoading(true);
    let resp = await CreateKnowledgeService.fileUpload(fileData, "questions");
    if (resp.status.toLowerCase() == "success") {
      setAttachment(resp.result[0]);
      setFileType(type);
      setFilename(files.name);
    } else if (resp.status.toLowerCase() == "error") {
      if (resp.message.toLowerCase() == "invalid file format") {
        /*  Swal.fire({
          text: "Invalid File format",
          toast: true,
        }); */
        toast("Invalid File format");
      } else {
        /*         Swal.fire({
          text: "Please try again",
          toast: true,
        }); */

        toast("Please try again");
      }
    }
    setLoading(false);
  };

  //upload

  const askQuery = async () => {
    if (platformId == "") {
      toast("Please select platform");
    } else if (systemId == "") {
      toast("Please select COE");
      // } else if (subSystemId == "") {
      //   toast("Please select sub COE");
    } else if (aggregate == "") {
      toast("Please select aggregate");
    } else if (title == "") {
      toast("Please enter title");
    } else if (description == "") {
      toast("Please enter description");
    } else {
      let reqData = {
        title: title,
        description: description,
        division_id: divisionId,
        platform_id: platformId,
        system_id: systemId,
        subsystem_id: subSystemId,
        AggreegateId: aggregate,
        video_id: "",
        transcription_data: "",
        thumbnailId: "",
        attachment: attachment,
        attachment_file_type: fileType,
      };

      const questionData = new FormData();

      questionData.append("title", title);
      questionData.append("description", description);
      // questionData.append("tag", tags);
      questionData.append("division_id", divisionId);
      questionData.append("platform_id", platformId);
      questionData.append("system_id", systemId);
      questionData.append("subsystem_id", subSystemId);
      questionData.append("attachment", attachment);

      questionData.append("attachment_file_type", fileType);
      questionData.append("video_id", "");
      questionData.append("transcription_data", "");
      questionData.append("thumbnailId", "");
      if (props?.knowledgeBaseId) {
        reqData.KnowledgebaseId = props?.knowledgeBaseId;
      }

      setLoading(true);
      const res = await AskAnExpertService.addQuery(reqData);
      if (res) {
        setFilename("");
        setSuccess(true);
        if (props?.knowledgeBaseId && props?.askQuestionCallback) {
          closeModal();
          props?.askQuestionCallback();
        } else {
          window.location.reload();
        }
      }
      setLoading(false);
    }
  };
  if (success && !props?.knowledgeBaseId) {
    return <Redirect to="/home" />;
  }
  return (
    <div>
      <Loadspinner
        filename="AskQuery.js"
        isLoading={isLoading}
        isMiddle="true"
      />
      {/* <div
        data-bs-toggle="modal"
        data-bs-target="#askanExpert"
        onClick={getLists}
        style={{ cursor: "pointer", fontSize: "10px" }}
      >
        <img src={images.ask_expert_active} className="header-navimg-ae" />
        <span className="header-text">Ask an expert</span>
      </div>

      <div
        className="modal fade"
        id="askanExpert"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="addInterestsLabel"
        aria-hidden="true"
      > */}
      <Modal
        open={showModal}
        onClose={closeModal}
        className="justify-space-around modal-dialog modal-lg modal-dialog-centered"
      >
        <div className="modal-content" style={{ borderRadius: "25px" }}>
          <div className="modal-header">
            <h5 className="modal-title popup-header">Ask a Query</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row card-row">
              {/* remove division */}
              {/* <div className="col-6 ">
                <label
                  className="form-check-label"
                // style={{ marginRight: "20px" }}
                >
                  Division
                </label>
                <br />
                {divisionList.map((division) => (
                  <div
                    className="form-check form-check-inline "
                    key={division.id}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      value={division.id}
                      checked={divisionId == division.id ? true : false}
                      onChange={setDivision}
                    />
                    <label className="form-check-label ">
                      {division.division_desc}
                    </label>
                  </div>
                ))}
              </div> */}
              <div className="col-6">
                <label className="form-check-label">Platform</label>
                <select
                  className="form-select"
                  required
                  onChange={(e) => setPlatformId(e.target.value)}
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {platformList.map((platform) => (
                    <option key={platform.id} value={platform.id}>
                      {platform.platform_desc}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row card-row">
              <div className="col-6">
                <label className="form-check-label">COE</label>
                <select className="form-select" required onChange={setSystem}>
                  <option value="" disabled selected>
                    Select
                  </option>
                  {systemList.map((system) => (
                    <option key={system.id} value={system.id}>
                      {system.system_desc}
                    </option>
                  ))}
                </select>
              </div>
              {/* <div className="col-6">
                <label className="form-check-label">Sub COE</label>
                <select
                  className="form-select "
                  disabled={isSystem}
                  required
                  onChange={(e) => setSubsystemId(e.target.value)}
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {subSystemList.map((subSystem) => (
                    <option key={subSystem.id} value={subSystem.id}>
                      {subSystem.subsystem_desc}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="col-6">
                <label className="form-check-label">Aggregate</label>
                <select
                  className="form-select "
                  disabled={false}
                  onChange={(e) => setAggregate(e.target.value)}
                  required
                  defaultValue={""}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {aggregateList.map((subSystem) => (
                    <option key={subSystem.value} value={subSystem.value}>
                      {subSystem.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row card-row">
              <label className="form-check-label">Title</label>
              <div className="col-12">
                <textarea
                  className="form-control"
                  rows="2"
                  required
                  placeholder="Enter here"
                  onChange={handleTitleChange}
                  value={title}
                />
              </div>
            </div>
            <div className="row card-row">
              <label className="form-check-label">Detailed Description</label>
              <div className="col-12">
                <textarea
                  className="form-control"
                  rows="3"
                  required
                  placeholder="Enter here"
                  onChange={handleDescriptionChange}
                  value={description}
                />
              </div>
            </div>

            <div className="row card-row">
              <label className="form-check-label">Upload File</label>
              <div className="col-12">
                <div
                  className="drop-container"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    margin: 0,
                    height: "60px",
                    border: "2px dashed #ced4da",
                  }}
                >
                  <div className="col-3">
                    <img
                      src={images.upload}
                      className="img-responsive"
                      width="30px"
                    />
                  </div>
                  <div className="col-6 message">
                    Attach Files(Text documents & Images)
                  </div>
                  <div className="col-3">
                    <input
                      type="file"
                      id="actual-btnn"
                      hidden
                      onChange={fileSelect}
                      autoComplete={CommonConstants.autoCompleteInput}
                    />
                    <label style={{ width: "100%" }} htmlFor="actual-btnn">
                      <a
                        variant="contained"
                        component="span"
                        style={{
                          width: "100%",
                          textDecoration: "underline",
                          // backgroundColor: "#198754",
                          color: "red",
                        }}
                        disabled={isLoading}
                      >
                        Choose File
                      </a>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="row card-row">
              {/* <div className="col-3">
                <input
                  type="file"
                  id="actual-btnn"
                  hidden
                  onChange={fileSelect}
                  accept="image/*,.xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel6k"
                />
                <label style={{ width: "100%" }} htmlFor="actual-btnn">
                  <Button
                    variant="contained"
                    component="span"
                    style={{
                      width: "100%",
                      backgroundColor: "#198754",
                      color: "white",
                    }}
                    disabled={isLoading}
                  >
                    Upload
                  </Button>
                </label>
              </div> */}
              <div className="col-6">
                <span>{fileName}</span>
              </div>
              <div className="col-3">
                <button
                  className="btn btn-danger"
                  style={{ width: "100%" }}
                  data-bs-dismiss="modal"
                  onClick={closeModal}
                >
                  Cancel
                </button>
              </div>
              <div className="col-3">
                <button
                  className="btn btn-danger"
                  style={{ width: "100%" }}
                  onClick={askQuery}
                  data-bs-dismiss="modal"
                  disabled={isLoading}
                >
                  Submit
                </button>
                <ToastContainer
                  position="top-center"
                  autoClose={5000}
                  hideProgressBar={true}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </div>
              {/* <div className="col-6">
                <a className="mt-2" style={{ fontSize: "10px", color: "red" }}>(* Allowed Only Text Documents & Images) </a>
              </div> */}
            </div>
          </div>
        </div>
      </Modal>
    </div>
    // </div>
  );
}

export default AskQuery;

AskQuery.propTypes = {
  handleModal: PropTypes.func,
  knowledgeBaseId: PropTypes.string,
  askQuestionCallback: PropTypes.func,
};
